import { useEffect, useState } from "react";
import axios from "axios";
import { BellRing, Loader2, Send, Check } from "lucide-react";
import { fmtDate } from "./AdminDashboard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const InviteRemindersCard = ({ token }) => {
  const [info, setInfo] = useState(null);
  const [state, setState] = useState("idle");
  const [queued, setQueued] = useState(0);
  const headers = { Authorization: `Bearer ${token}` };

  const load = () => axios.get(`${API}/admin/invite-reminders`, { headers }).then((r) => setInfo(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const run = async () => {
    if (!info) return;
    if (!window.confirm(`Send invite reminders to ${info.eligible} artist${info.eligible === 1 ? "" : "s"} now?`)) return;
    setState("sending");
    try {
      const { data } = await axios.post(`${API}/admin/invite-reminders/run`, {}, { headers });
      setQueued(data.queued);
      setState("sent");
      setTimeout(() => { setState("idle"); load(); }, 6000);
    } catch (err) {
      alert(err.response?.data?.detail || "Could not start the reminder run.");
      setState("idle");
    }
  };

  const last = info?.last_run;
  return (
    <div className="latest-card reminders-card" data-testid="invite-reminders-card">
      <p className="latest-label"><BellRing size={12} style={{ verticalAlign: "-1px", marginRight: 6 }} />INVITE REMINDERS · DAILY 9AM</p>
      {!info ? (
        <Loader2 size={20} className="spin gold" />
      ) : (
        <>
          <div className="reminders-row">
            <span className="admin-counter-value" data-testid="reminders-eligible">{info.eligible}</span>
            <span className="reminders-copy">
              artist{info.eligible === 1 ? "" : "s"} due a reminder<br />
              <span className="reminders-sub">no login after 7+ days · max {info.max_reminders}, a week apart</span>
            </span>
          </div>
          <p className="reminders-last" data-testid="reminders-last-run">
            {last ? `Last run ${fmtDate(last.started_at)} · ${last.sent} sent${last.failed ? `, ${last.failed} failed` : ""}${last.status === "running" ? " · running…" : ""}` : "No reminders sent yet"}
          </p>
          <button
            className={`btn-announce btn-admin-link reminders-btn ${state === "sent" ? "is-done" : ""}`}
            onClick={run}
            disabled={state !== "idle" || info.eligible === 0 || last?.status === "running"}
            data-testid="send-reminders-btn"
          >
            {state === "sending" ? <Loader2 size={15} className="spin" /> : state === "sent" ? <Check size={15} /> : <Send size={15} />}
            {state === "sending" ? "STARTING..." : state === "sent" ? `SENDING TO ${queued}` : "SEND REMINDERS NOW"}
          </button>
        </>
      )}
    </div>
  );
};
